import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { SortModel } from "../../home/models/PageTypes";
import { EditPictureModel, FileType } from "../../pictures/models/PictureModel";
import { NewFeedEntryModel, NewFeedFilterModel, NewFeedModel } from "../models/NewFeedModel";
import { NewFeedAdminService } from "../services/NewFeedService";

export function useNewFeedVM() {
    const feedService = new NewFeedAdminService();

    const [feeds, setFeeds] = useState<NewFeedModel[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [selectedItem, setSelectedItem] = useState<NewFeedModel | undefined>(undefined);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [pageHash, setPageHash] = useState<number>(0);
    const [listHash, setListHash] = useState<number>(0);
    const [loading, setLoading] = useState(false);
    const [showEntry, setShowEntry] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    const [showFilter, setShowFilter] = useState(false);

    const {
        form: filter,
        setForm: setFilter,
        resetForm: resetFilter,
        setField: setFilterField
    } = useForm<NewFeedFilterModel>({
        isOpen: false,
        type: FileType.any,
        referenceId: 0,
        search: "",
        pageNumber: 1,
        pageSize: 50,
        sortModel: new SortModel(),
        pagingDisabled: false
    });

    const {
        form: inputForm,
        setForm: setInputForm,
        resetForm: resetInputForm,
        setField: setInputField
    } = useForm<NewFeedEntryModel>({
        id: 0,
        brand: "",
        title: "",
        description: "",
        url: "",
        start: new Date(),
        end: new Date(),
        type: FileType.image,
        order: 1,
        referenceId: undefined
    });

    const getList = (pageChange = false) => {
        console.log("New Feed getList");
        setFeeds([]);
        setLoading(true);
        setListHash(Utils.getRandomKey());

        const request = feedService.search(filter);

        DataUtils.onRequest(request, (result: IDataResult) =>
            getListResult(result, pageChange));
    }

    const getListResult = (result: IDataResult, pageChange = false) => {
        if (result.status === ResponseStatus.success) {
            setFeeds(result.data.items);
            setTotalCount(result.data.totalCount);
            setListHash(Utils.getRandomKey());

            if (!pageChange) {
                setPageHash(Utils.getRandomKey() + 100);
            }
        }

        setLoading(false);
    }

    const get = (id: number) => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setSelectedItem(result.data);
            }
        }
        const request = feedService.get(id);
        DataUtils.onRequest(request, onResult);
    }

    const create = () => {
        setLoading(true);
        const request = feedService.create(inputForm);
        DataUtils.onRequest(request, onResult);
    }

    const edit = () => {
        setLoading(true);
        const request = feedService.edit(inputForm.id, inputForm);
        DataUtils.onRequest(request, onResult);
    }

    const onResult = (response: IDataResult) => {
        if (response.status === ResponseStatus.success) {
            setIsEdit(false);
            setShowEntry(false);
            getList();
            if (selectedItem) get(selectedItem.id);
        }

        setLoading(false);
    }

    const activate = (id: number, value: boolean) => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                getList();
            }

            setLoading(false);
        }

        setLoading(true);
        const request = feedService.activate(id, value);
        DataUtils.onRequest(request, onResult);
    }

    ///////////////////////// Pictures //////////////////////////////////
    const getPictureList = (ownerId: number) => {
        return feedService.getPictures(ownerId);
    }

    const deletePicture = (ownerId: number, id: number) => {
        return feedService.deletePicture(ownerId, id);
    }

    const createPicture = (ownerId: number, model: FormData) => {
        return Utils.postFormData(model, feedService.RouteCreatePictures(ownerId));
    }

    const editPicture = (ownerId: number, picture: EditPictureModel) => {
        return feedService.editPicture(ownerId, picture);
    }

    const editPictureList = (ownerId: number, pictures: EditPictureModel[]) => {
        return feedService.editPictures(ownerId, pictures);
    }

    return {
        feeds,
        totalCount,
        selectedItem,
        setSelectedItem,
        isEdit,
        setIsEdit,

        filter,
        setFilter,
        resetFilter,
        setFilterField,

        inputForm,
        setInputForm,
        resetInputForm,
        setInputField,

        getList,
        get,
        create,
        edit,
        activate,

        pageHash,
        listHash,
        loading,
        setLoading,
        showEntry,
        setShowEntry,
        showDetail,
        setShowDetail,
        showFilter,
        setShowFilter,

        getPictureList,
        deletePicture,
        createPicture,
        editPicture,
        editPictureList
    }
}